module.exports = __webpack_public_path__ + "img/1.d9e8578b.webp";